module.exports = __webpack_public_path__ + "f2fd325e5718d72b313171f6a0aa3d82.pdf";